export interface WalletLoginModalState {
    connected: boolean;
    logged: boolean;
    loginPending?: boolean;
    loginError?: unknown;
}

export const shouldShowWalletLoginModal = (state: WalletLoginModalState): boolean => {
    return state.connected && !state.logged && (!!state.loginPending || !!state.loginError);
};

